import { combineReducers } from "redux";
import pages from "./pageReducer";
import clients from "./clientReducer";
import leaseEvents from "./leaseEventReducer";
import leases from "./leaseReducer";
import properties from "./propertyReducer";
import references from "./referenceReducer";
import transactions from "./transactionReducer";
import currentUser from "./userReducer";
import userSettings from "./userSettingsReducer";
import activeDirectory from "./activeDirectoryReducer";
import admin from "./adminReducer";
import manualUpload from "./manualUploadReducer";
import usageInsight from "./usageInsightReducer";

const rootReducer = {
  pages,
  clients,
  leaseEvents,
  leases,
  properties,
  references,
  transactions,
  currentUser,
  userSettings,
  activeDirectory,
  admin,
  manualUpload,
  usageInsight,
  // auth
};

export default rootReducer;
